module.exports = __webpack_public_path__ + "img/startapplication.a55d15db.png";